import axios from 'axios';
import { API_BASE_URL } from 'configs/AppConfig';
import { signOutSuccess } from 'store/slices/authSlice';
import store from '../store';
import { AUTH_TOKEN } from 'constants/AuthConstant';
import { notification } from 'antd';
import Cookies from 'js-cookie';

const unauthorizedCode = [402, 401, 403]

const service = axios.create({
  	baseURL: API_BASE_URL,
  	timeout: 60000,
	withCredentials: true,
})

// Config
//const TOKEN_PAYLOAD_KEY = 'Authorization'

// API Request interceptor
service.interceptors.request.use(config => {
	const jwtToken =Cookies.get(AUTH_TOKEN) || null;

	if (jwtToken) {
	}

	// Add OPTIONS-specific headers and logic, if needed
	if (config.method === 'OPTIONS') {
	}

	// Set responseType blob untuk export file
	if (config.data?.export_as === 'csv' || config.data?.export_as === 'xlsx') {
		config.responseType = 'blob';
	}


	return config
}, error => {
	// Do something with request error here
	notification.error({
		message: 'Error',
        style: {
            backgroundColor: '#f8d7da',
            borderRadius: '4px',
            border: '1px solid #f5c2c7',
            color: '#842029',
        },
        className: 'custom-error-notification'
	})
	Promise.reject(error)
})

// API respone interceptor
service.interceptors.response.use( (response) => {
	// Jika responseType blob, return response langsung
	if (response.config.responseType === 'blob') {
		return response.data
	}

	return response.data
}, (error) => {
	let notificationParam = {
		message: ''
	}

	// Remove token and redirect
	if (unauthorizedCode.includes(error.response.status)) {
		notificationParam.message = 'Autentikasi Gagal'
		notificationParam.description = 'Silahkan Login Ulang'
		localStorage.removeItem(AUTH_TOKEN)

		store.dispatch(signOutSuccess())
	}


	if (error.response.status === 404) {
		notificationParam.message = 'Not Found'
	}

	if (error.response.status === 500) {
		notificationParam.message = 'Internal Server Error'
	}

	if (error.response.status === 508) {
		notificationParam.message = 'Time Out'
	}

	notification.error(notificationParam)

	return Promise.reject(error);
});

export default service
